import React from "react";
import { useState } from "react";
import "../../style/portfolio.css";
import todoDesktop from "../../images/todoDesktop.jpg";
import todoMobile from "../../images/todoMobile.jpg";

const TodoApp = () => {
  const [desktop, setDesktop] = useState(true);
  const desktopImg = () => {
    setDesktop(true);
  };
  const mobileImg = () => {
    setDesktop(false);
  };

  return (
    <div className="portfolio-element">
      <div className="portfolio-left">
        <img src={desktop ? todoDesktop : todoMobile} alt="CRUD App" />
        <br />
        <button
          className={desktop ? "btn-active" : "btn-inactive"}
          onClick={desktopImg}
        >
          DISEÑO DESKTOP
        </button>
        <button
          className={desktop ? "btn-inactive" : "btn-active"}
          onClick={mobileImg}
        >
          DISEÑO MOVIL
        </button>
      </div>
      <div className="portfolio-right">
        <h1 className="headings-portfolio">TODO App</h1>
        <p>
          Aplicación creada con React y conectada a la base de datos Mysql con
          Node.js. La aplicación permite al usuario crear, eliminar, editar y
          borrar tareas completadas. Las tareas se pueden filtrar por activo o
          completada. Además, la aplicación presenta un modo oscuro creado con
          Styled Components. Las solicitudes HTTP se manejan a través de Axios.
        </p>
        <a target="blank" href="https://todo-redux-sql.netlify.app/">
          <button className="btn-visitar">Ver proyecto</button>
        </a>
        <a
          target="blank"
          href="https://github.com/khanchandanivikas/todo-portfolio-frontend"
        >
          <button className="btn-visitar">Ver codigo</button>
        </a>
      </div>
    </div>
  );
};

export default TodoApp;
